import { Col, Row, Select } from "antd"
import { useSelector } from "react-redux";
import { ApplicationState } from "store";
import mask from "utils/mask";

export const SelectTransporter: React.FC<{
  setSelectedTransporter: React.Dispatch<React.SetStateAction<number | undefined>>;
}> = ({ setSelectedTransporter }) => {

  const { Option } = Select;
  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const loadingtransp = useSelector((state: ApplicationState) => state.Transportadoras.loading);

  return (
    <Row gutter={24}>
      <Col md={24} sm={24} xs={24}>
        <Select
          loading={loadingtransp}
          id="codTransportadorasCadastradas"
          placeholder={'Selecione uma transportadora'}
          showSearch
          filterOption={(inputValue, element) =>
            element?.props.children
              .toString()
              .toLowerCase()
              .replace(/\.|-|\//g, '')
              .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
          }
          onChange={(e) => setSelectedTransporter(Number(e))}
          style={{ width: "100%" }}

        >
          {transportadoras?.map((transp: any, index) => (
            <Option value={transp.codParceiro} key={transp.codParceiro + index}>
              {mask("camelCase", transp.nomeParceiro)}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  )
}
